import strings from 'strings';

const REQUIRED_MESSAGE = strings.inventory.quickEntry.validations.required;

export const getRequiredNonBlankRules = (message = REQUIRED_MESSAGE) => ({
  required: message,
  validate: value => (typeof value === 'string' && value.trim() !== '' ? true : message)
});
